import assoc from "ramda/es/assoc"
import assocPath from "ramda/es/assocPath"
import compose from "ramda/es/compose"
import identity from "ramda/es/identity"
import dissocPath from "ramda/es/dissocPath"
import map from "ramda/es/map"
import evolve from "ramda/es/evolve"
import filter from "ramda/es/filter"
import equals from "ramda/es/equals"
import complement from "ramda/es/complement"
import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import {
  updateEventMap,
  updateResourceMap,
  updateDataList,
  updateRecordMap,
} from "./utils"
import {
  LOAD_CALENDAR_STARTED,
  LOAD_CALENDAR_COMPLETED,
  LOAD_CALENDAR_FAILED,
  INIT_CALENDAR_STARTED,
  INIT_CALENDAR_COMPLETED,
  INIT_CALENDAR_FAILED,
  ADD_EVENT,
  UPDATE_EVENT,
  REMOVE_EVENT,
} from "../actions/types"

const INITIAL_STATE = {
  eventMap: {},
  resourceMap: {},
  recordMap: {},
  dataList: [],
  meta: {
    status: INITIAL,
    count: null,
  },
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action
  switch (type) {
    case LOAD_CALENDAR_STARTED: {
      return assocPath([`meta`, `status`], PENDING)(state)
    }
    case LOAD_CALENDAR_COMPLETED: {
      return compose(
        assocPath([`meta`, `status`], COMPLETED),
        payload.keepCount
          ? identity
          : assocPath([`meta`, `count`], payload.count),
        assoc(
          `resourceMap`,
          updateResourceMap(payload.data, state.resourceMap),
        ),
        assoc(`eventMap`, updateEventMap(payload.data, state.eventMap)),
        assoc(`recordMap`, updateRecordMap(payload.data, state.recordMap)),
        assoc(`dataList`, updateDataList(payload.data, state.dataList)),
      )(state)
    }
    case LOAD_CALENDAR_FAILED: {
      return assocPath([`meta`, `status`], FAILED)(state)
    }
    case INIT_CALENDAR_STARTED: {
      return assocPath([`meta`, `status`], PENDING)(INITIAL_STATE)
    }
    case INIT_CALENDAR_COMPLETED: {
      return compose(
        assocPath([`meta`, `status`], COMPLETED),
        assocPath([`meta`, `count`], payload.count),
        assoc(
          `resourceMap`,
          updateResourceMap(payload.data, state.resourceMap),
        ),
        assoc(`eventMap`, updateEventMap(payload.data, state.eventMap)),
        assoc(`recordMap`, updateRecordMap(payload.data, state.recordMap)),
        assoc(`dataList`, updateDataList(payload.data, state.dataList)),
      )(state)
    }
    case INIT_CALENDAR_FAILED: {
      return assocPath([`meta`, `status`], FAILED)(state)
    }
    case ADD_EVENT: {
      const addEvent = compose(
        assocPath([`eventMap`, payload.event.uuid], payload.event),
        evolve({
          recordMap: map(record =>
            payload.resources.some(one => one.uuid === record.resource)
              ? {
                  ...record,
                  items: [...record.items, payload.event.uuid],
                }
              : record,
          ),
        }),
      )

      return addEvent(state)
    }
    case UPDATE_EVENT: {
      const updateEvent = assocPath(
        [`eventMap`, payload.event.uuid],
        payload.event,
      )

      return updateEvent(state)
    }
    case REMOVE_EVENT: {
      const removeEvent = compose(
        dissocPath([`eventMap`, payload.event.uuid]),
        evolve({
          recordMap: map(
            evolve({ items: filter(complement(equals(payload.event.uuid))) }),
          ),
        }),
      )

      return removeEvent(state)
    }
    default:
      return state
  }
}
